import * as actionTypes from "./actions";

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTION_TYPE:
      // Do something for action type
      return {
        ...state
      };
    default:
      return {
        ...state
      };
  }
};

export default reducer;
